import BooleanAttribute from './BooleanAttribute'

export default BooleanAttribute
